<template>
    <div :class="'tariffitem ' + this.swiperClass">
        <div class="img-txt-teaser-tariffoffer">
            <div class="img">
                <img :src="absolutizeUrl(settings.tarif.bildurl)" alt="" v-if="settings.tarif.bildurl">
            </div>
            <div class="txt">
                <div class="head" v-html="settings.tarif.nameExtern"/>
                <span class="addition text-center" v-if="settings.tarif.commodity === 1">Ökostrom</span>
                <div class="sub" v-html="settings.tarif.unterzeile"/>
                <div class="sum">
                    {{ preis_formatted }}
                    <span class="append">Ø pro Monat</span>
                    <span class="info-button"
                          data-trigger="hover"
                          data-container="body"
                          data-toggle="popover"
                          data-placement="top"
                          :data-content="settings.tarif.preis_info"
                          v-if="settings.tarif.preis_info"
                    ></span>
                    <div style="opacity: 1" v-if="settings.tarif.jvl && settings.tarif.jvl_hoehe > 0 && formData.jvl > 0" id="rabatt" class="">inkl. {{ settings.tarif.jvl_hoehe }} % Rabatt bei Jahreszahlung</div>
                    <div id="coupon" v-if="gutschein && gutschein.uid">
                        inkl. {{ gutschein.art }} {{ gutschein.wert }} {{ gutschein.wert_einheit === 'Euro' ? '€' : '%' }}
                    </div>
                </div>

            </div>
            <div class="calc-list">
                <div class="head">Ihre Angaben</div>
                <dl>
                    <dt>Postleitzahl:</dt>
                    <dd>{{ formData.lieferadresse_plz }}</dd>
                    <dt>Jahresverbrauch:</dt>
                    <dd>{{ verbrauch_formatted }}</dd>
                </dl>
            </div>
            <div class="calc-collapse">
                <a class="collapsed" data-toggle="collapse" href="#collapseCalcChange" role="button"
                   aria-expanded="false" aria-controls="collapseCalcChange">
                    Angaben ändern
                </a>
                <div class="collapse" id="collapseCalcChange">
                    <medium-loader v-if="loading" />
                    <template v-else>
                        <div class="calc-select">
                            <div class="alert alert-danger" v-if="errorMessage" v-html="errorMessage"></div>

                            <div class="select-zipcode">
                                <div class="calc-form-label-group">
                                    <input type="text" id="inputPLZStrom" class="form-control"
                                           placeholder="Ihre PLZ" :value="formData.lieferadresse_plz" disabled>
                                    <label for="inputPLZStrom">Ihre PLZ</label>
                                </div>
                            </div>
                            <div class="select-consumption">

                                <div class="calc-form-label-group">
                                    <input type="text" class="form-control" v-model="verbrauch">
                                    <label>Verbrauch</label>
                                </div>
                            </div>
                        </div>
                        <div class="txt">
                            <div class="options">
                                <div>
                                    <div class="options-intro" v-if="settings.tarif.commodity === 1">
                                        <p v-if="settings.tarif.unterzeile_produkthighlight" class="heart-icon">
                                            {{ settings.tarif.unterzeile_produkthighlight }}</p>
                                        <p v-if="settings.tarif.zusatzzeile_produkthighlight" class="font-green"
                                           v-html="settings.tarif.zusatzzeile_produkthighlight"></p>
                                    </div>
                                </div>

                                <preisoptions-gruppe
                                    v-for="gruppe in settings.tarif.preisoptionen"
                                    :key="gruppe.uid" :gruppe="gruppe"
                                    @input="form.setValue('preisoptionen', $event)"
                                    :value="form?.fields?.preisoptionen?.value || {}"
                                    :commodity="settings.tarif.commodity"
                                />

                            </div>
                            <button type="button" class="btn btn-primary btn-refresh" @click.prevent="calculate">Neu
                                berechnen
                            </button>
                        </div>
                    </template>
                </div>
            </div>

            <div class="txt">
                <!-- START details -->
                <div ref="details" class="details collapse" id="collapseTarifDetails">
                    <div class="inner" v-html="settings.tarif.kurzbeschreibung"/>
                    <div class="inner" v-if="settings.tarif.anhaenge_anzeigen">
                        <ul class="linklist" v-if="settings.tarif.agb || settings.tarif.besondere_bedingungen || settings.tarif.preisblatturl">
                            <li v-if="settings.tarif.agburl"><a :href="absolutizeUrl(settings.tarif.agburl)">AGB</a></li>
                            <li v-if="settings.tarif.besondere_bedingungenurl"><a :href="absolutizeUrl(settings.tarif.besondere_bedingungenurl)">Besondere Bedingungen</a></li>
                            <li v-if="settings.tarif.preisblatt && settings.tarif.preisblatturl"><a :href="settings.tarif.preisblatturl">Preisblatt</a></li>
                        </ul>
                    </div>
                </div>
                <!-- END details -->
                <div class="button-details">
                    <button class="collapsed" type="button" data-toggle="collapse"
                            data-target="#collapseTarifDetails" aria-expanded="false"
                            aria-controls="collapseTarifDetails" @click="scrollToDetails">Tarifdetails
                    </button>
                </div>
            </div>


            <div :class="'gradient ' + this.gradientClass"></div>
        </div>
    </div>
</template>
<script>
import PreisoptionsGruppe from "@/components/PreisoptionsGruppe";
import MediumLoader from "@/components/Loader/MediumLoader";
import FormAware from "@/mixins/FormAware";
import {berechneJahrespreis, berechneMonatsabschlag, berechneMonatspreis} from "@/util/tarif";
import { getTarife } from "@/service/getTarife";
import urlMixin from "@/mixins/urlMixin";

export default {
    name: 'BestellstreckeTarifkarte',
    inject: ['settings', 'gutschein'],
    mixins: [FormAware, urlMixin],
    props: ['formData'],
    components: { MediumLoader, PreisoptionsGruppe },
    computed: {
        verbrauch_formatted() {
            return (parseInt(this.formData.tarif_verbrauch) || 0).toLocaleString() + ' kWh';
        },
        preis_formatted() {
            return berechneMonatspreis(this.tarif, this.formData.tarif_preis, this.formData.preisoptionen, this.formData.jvl).format();
        },
        swiperClass(){
            if(this.tarif.farbigkeit == 'gruen') return 'tarif-green';
            return '';
        },
        gradientClass(){
            if(this.tarif.farbigkeit == 'gruen') return 'gradient-green';
            return 'gradient-orange';
        },
    },
    data() {
        return {
            tarif: this.settings.tarif,
            verbrauch: '',
            isFocused: false,
            loading: false,
            errorMessage: '',
        }
    },
    methods: {
        async calculate() {
            this.loading = true;
            this.errorMessage = '';
            getTarife(
                this.settings.tarifUrl,
                this.formData.tarif_typ,
                this.formData.lieferadresse_plz + ', ' + this.formData.lieferadresse_ort,
                this.formData.lieferadresse_codenummer,
                this.verbrauch,
                this.formData.tarif_id,
                1
            )
            .then(data => {
                this.loading = false;
                if (data && data.length === 1 && data[0].uid === this.formData.tarif_id) {
                    this.tarif = data[0]; // Tarif anpassen damit tarif.preiseMitRabatt in der Preisberechnung beachtet werden können
                    this.form.setValue('tarif_preis', data[0].preis);
                    this.form.setValue('tarif_preis_id', data[0].preis_id);
                    this.form.setValue('tarif_verbrauch', this.verbrauch);
                    this.$emit('renderPopover');

                    // geänderten verbrauch im localStorage speichern
                    let preisrechner = localStorage.preisrechner;
                    preisrechner = JSON.parse(preisrechner);
                    preisrechner[this.settings.preisrechner.rid].tarifTypValue['gas'].verbrauch = this.verbrauch
                    preisrechner.tarifTypValue['gas'].verbrauch = this.verbrauch
                    localStorage.preisrechner = JSON.stringify(preisrechner);

                } else {
                    this.errorMessage = 'Wir konnten keinen passenden Tarif mit den Angaben finden.';
                }
            })
            .catch(error => {
                console.log('getTarife', error);
                this.loading = false;
            })
        },
        scrollToDetails(e) {
            const el = e.target.ariaExpanded === 'true' ? this.$el : this.$refs.details;
            if (el) {
                setTimeout(() => {
                    console.log('scrolling');
                    el.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center',
                    });
                }, 350)
            }
        },
        setPreisFormatted(e){
            this.$emit('setFValue', 'tarif_monatspreis', e);
            this.$emit('setFValue', 'tarif_jahrespreis', berechneJahrespreis(this.tarif, this.formData.tarif_preis, this.formData.preisoptionen, this.formData.jvl).format());
            this.$emit('setFValue', 'tarif_monatsabschlag', berechneMonatsabschlag(this.tarif, this.formData.tarif_preis, this.formData.preisoptionen, this.tarif.preiseMitRabatt.type, this.formData.jvl).format());
        }
    },
    watch: {
        'formData.tarif_verbrauch': function (newVebrauch) {
            this.verbrauch = newVebrauch;
        },
        preis_formatted: function (newValue){
            this.setPreisFormatted(newValue);
        }
    },
}
</script>
